import { Checkbox, Column, Row, Text } from '~/commonComponents';
import { Date as JobDate } from '~/components/Schedule/components/JobCard/components/Date';
import { getJobStatus } from '~/components/Dashboard/ReceiptList/utils';
import { UserProfession, UserSubProfession } from '~/enums/UserProfession';
import { format, parse } from 'date-fns';
import { ChevronRight } from '~/images/icons';
import { Colors } from '~/themes/colors';

interface IInterviewRowProps {
  date: string;
  endTime: string;
  isSelected: boolean;
  onsiteInterviewId: string;
  profession: string;
  startTime: string;
  status: string;
  subProfession: string | null;
  onToggle: (id: string) => void;
}

export const InterviewRow = ({
  date,
  endTime,
  isSelected,
  onsiteInterviewId,
  profession,
  startTime,
  status,
  subProfession,
  onToggle,
}: IInterviewRowProps) => {
  const { color, label } = getJobStatus(status);

  return (
    <Row
      alignItems="center"
      aria-label={`Interview on ${date}`}
      borderRadius={8}
      className="shadow-xs hover__shadow-sm"
      cursor="pointer"
      data-testid="interview-row"
      gap={12}
      paddingBlock={8}
      paddingInline={20}
      role="button"
      onClick={() => onToggle(onsiteInterviewId)}
    >
      <Checkbox checked={isSelected} />
      <Row flex={1} gap={12}>
        <JobDate
          backgroundColor={color}
          localDate={format(parse(date, 'EEE, MMM d, yyyy', new Date()), 'yyyy-MM-dd')}
        />
        <Column flex={1}>
          <Text bold>
            {UserSubProfession.getName(subProfession || '') || UserProfession.getName(profession)}
          </Text>
          <Text>
            {startTime} - {endTime}
          </Text>
          <Text color={color}>{label}</Text>
        </Column>
      </Row>
      <ChevronRight color={Colors.secondary_500} size={24} />
    </Row>
  );
};
